/**
 * Ligatures and letters that NFKD does NOT decompose into their base letters —
 * they are single letters in Unicode, not an accent over a base. Without this map
 * "sœur" would slugify to "s-ur". Handled before normalization.
 */
const LIGATURES: Record<string, string> = {
  œ: 'oe', 
  Œ: 'oe',
  æ: 'ae', 
  Æ: 'ae',
  ß: 'ss',
  ø: 'o', 
  Ø: 'o',
  ð: 'd', 
  Ð: 'd',
  þ: 'th', 
  Þ: 'th',
  ł: 'l', 
  Ł: 'l'
};

/**
 * Turn a display name into an ASCII slug, transliterating accented letters to
 * their base form rather than dropping them: "Wafacash Sénégal" → "wafacash-senegal"
 * (not "wafacash-s-n-gal").
 *
 * NFKD splits an accented character into its base letter plus a combining mark,
 * then the combining-marks range (U+0300–U+036F) is stripped, leaving the plain
 * letter. Ligatures NFKD leaves intact (œ, æ, ß…) are expanded first via
 * `LIGATURES`. Everything that isn't a letter or digit collapses to a single
 * hyphen, and leading/trailing hyphens are trimmed.
 */
export const slugify = (value: string): string =>
  value
    .replace(/[œŒæÆßøØðÐþÞłŁ]/g, (ch) => LIGATURES[ch] ?? ch)
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export default slugify;
